<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.riesgo.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item.$model" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.riesgo_preconcepcional.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtonsNoOptions';
import riesgoPreconcepcionalService from '../../../../services/riesgoPreconcepcionalService';
import historiaRiesgoPreconcepcionalService from '../../../../services/historiaRiesgoPreconcepcionalService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from '../../../../components/common/utilities/toast';

export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            riesgo: []
        }
    },
    validations(){
        return {
            riesgo:{
                $each:{
                    riesgo_preconcepcional:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let riesgo_usuario = [];

                this.riesgo.forEach((x) => {
                    if (x.riesgo_preconcepcional.valor !== "") {
                        riesgo_usuario.push({ ...x.riesgo_preconcepcional });
                    }
                });

                this.LoaderSpinnerShow();
                await historiaRiesgoPreconcepcionalService.store({
                    riesgo_usuario: riesgo_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                this.LoaderSpinnerHide();
                console.log(error);
                Toast.fire({
                    icon: 'error',
                    title: 'Ha ocurrido un error al procesar la solicitud'
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await riesgoPreconcepcionalService.index({
            params: filter
        });

       const riesgo_usuario = await historiaRiesgoPreconcepcionalService.index(
            this.idHistoria
        ); 

        const response_last = await historiaRiesgoPreconcepcionalService.showLast(this.usuario.id);

        if(!isEmpty(riesgo_usuario.data)){
            this.riesgo = response.data.map((y) => {
                const indice = riesgo_usuario.data.findIndex(
                    (a) => a.id_riesgo_preconcepcional === y.id
                );
                y.riesgo_preconcepcional = {
                    id: indice !== -1 ? riesgo_usuario.data[indice].id : 0,
                    id_riesgo_preconcepcional: y.id,
                    id_historia:this.idHistoria,
                    valor: indice !== -1 ? riesgo_usuario.data[indice].valor : "",
                };
                return y;
            }); 
        }else if(!isEmpty(response_last.data && response_last.data.riesgo_preconcepcional)){
            
            
                this.riesgo = response.data.map((y) => {
                    const indice = response_last.data.riesgo_preconcepcional.findIndex(
                        (a) => a.id_riesgo_preconcepcional === y.id
                    );
                    y.riesgo_preconcepcional = {
                        id: 0,
                        id_riesgo_preconcepcional: y.id,
                        id_historia:this.idHistoria,
                        valor: indice !== -1 ? response_last.data.riesgo_preconcepcional[indice].valor : "",
                    };
                    return y;
                }); 
            
            
        }else{

            this.riesgo=this.riesgo = response.data.map((y) => {
                const indice = response.data.findIndex(
                    (a) => a.id_riesgo_preconcepcional === y.id
                );
                y.riesgo_preconcepcional = {
                    id: 0,
                    id_riesgo_preconcepcional: y.id,
                    id_historia:this.idHistoria,
                    valor: indice !== -1 ? response.data[indice].valor : "",
                };
                return y;
            });

        }
    }

}
</script>